import createRoute from '@widesk-ui/tools/createRoute';
import CartModel   from '@models/shop/CartModel';

export default createRoute.splitView('/entertainments/:entertainmentId/carts', 'shop', 'CartSplitView', CartModel.localize('plural'));
